/* eslint-disable radix */
/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
import React, { useState, useRef, useEffect } from 'react';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import axios from 'axios';
import 'react-rangeslider/lib/index.css';

import TVForm from './TVForm';

const ActiveTVController = ({ data, token, id }) => {
  //  * STATE
  const [activeTypes, setActiveTypes] = useState([]);
  const [listViewInput, setListViewInput] = useState(false);
  const [showPricesInput, setShowPricesInput] = useState(false);
  const [shoutTickerInput, setShoutTickerInput] = useState(false);
  const [listViewDurationInput, setListViewDurationInput] = useState(1);
  const [tvDurationInput, setTvDurationInput] = useState(3);
  const [tvNameInput, setTvNameInput] = useState('');
  const [albums, setAlbums] = useState([]);
  const [controlOpen, setControlOpen] = useState(true);
  const [activeTV, setActiveTV] = useState(data);
  const [allSections, setAllSections] = useState([]);
  const [loading, setLoading] = useState({
    sections: true,
    albums: true,
  });
  const [showSectionToggle, setShowSectionToggle] = useState(false);
  const [showGalleryToggle, setShowGalleryToggle] = useState(false);

  //  * REF'S
  const durationRef = useRef(null);
  const tickerRef = useRef(null);
  const pricesRef = useRef(null);
  const activeTypesRef = useRef(null);
  const listViewRef = useRef(null);
  const listSpeedRef = useRef(null);

  useEffect(() => {
    // This useEffect fetches section data as well as album data and adds the data to state
    axios
      .get(`/api/proxy/v2/businesses/${id}/sections`)
      .then(({ data }) => {
        setAllSections(
          flattenSections(data.sections).map(sec => ({
            label: sec.name,
            value: sec,
          }))
        );
        setLoading({
          ...loading,
          sections: false,
        });
      })
      .catch(error => {
        console.error(error);
        setLoading({
          ...loading,
          sections: false,
        });
      });

    axios
      .get(`/api/proxy/v2/businesses/${id}/albums`)
      .then(({ data }) => {
        setAlbums(data.items);
        setLoading({
          ...loading,
          albums: false,
        });
      })
      .catch(error => {
        console.error('error', error);
        setLoading({
          ...loading,
          albums: false,
        });
      });
  }, []);

  useEffect(() => {
    setActiveTV(data)
    setControlOpen(true)
    setTvNameInput('')
  }, [data]);

  useEffect(() => {
    // * This useEffect updates all the local state based on whats coming from the backend.

    if (activeTV.showTicker) {
      setShoutTickerInput(activeTV.showTicker);
    }
    if (activeTV.showPrices) {
      setShowPricesInput(activeTV.showPrices);
    }
    if (activeTV.displayType && activeTV.displayType.type) {
      setListViewInput(activeTV.displayType.type !== 'default');
    }
    if (activeTV.activeTypes) {
      if (activeTV.activeTypes.list1) {
        setActiveTypes(activeTV.activeTypes.list1);
      }
    }
    if (activeTV.slideDuration) {
      setTvDurationInput(millisToMinutesAndSeconds(activeTV.slideDuration));
    }
    if (activeTV.otherOptions && activeTV.otherOptions.listViewDuration) {
      setListViewDurationInput(activeTV.otherOptions.listViewDuration);
    }

  }, [activeTV]);

  const millisToMinutesAndSeconds = millis => millis / 1000;

  const toolTipContent = {
    duration: 'How long each slide gets to be on display for before changing',
    ticker:
      'Displays a ticker at the bottom of the TV, displaying your latest announcements',
    prices: 'Toggle menu item prices ON or OFF',
    activeTypes: 'Choose to show menu items, events, photos and shout',
    listView:
      'List view displays a continuous, scrolling list of all your menu items. (Shout, events and photos are not displayed)',
    listSpeed:
      'How fast the list view takes to scroll to the bottom. Larger menus require more time.',
  };

  const handleViewType = type => {
    axios
      .put(
        `/api/proxy/v2/businesses/${id}/gntv/${activeTV.id}`,
        {
          ...activeTV,
          displayType: {
            type,
          },
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(({ data }) => {
        setActiveTV(data);
        // noop
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleSwitch = name => {
    // todo refactor to be more concise. Too many nested IF's.
    if (name !== 'listView') {
      const getVal = () => {
        if (name === 'showTicker') {
          return !shoutTickerInput;
        }
        if (name === 'showPrices') {
          return !showPricesInput;
        }
      };

      axios
        .put(
          `/api/proxy/v2/businesses/${id}/gntv/${activeTV.id}`,
          {
            ...activeTV,
            [name]: getVal(),
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then(({ data }) => {
          setActiveTV(data);
          if (name === 'showTicker') {
            setShoutTickerInput(!shoutTickerInput);
          }
          if (name === 'showPrices') {
            setShowPricesInput(!showPricesInput);
          }
        })
        .catch(error => {
          console.error(error);
        });
    } else {
      setListViewInput(!listViewInput);
      axios
        .put(
          `/api/proxy/v2/businesses/${id}/gntv/${activeTV.id}`,
          {
            ...activeTV,
            displayType: {
              type: listViewInput ? 'default' : 'list',
            },
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then(({ data }) => {
          setActiveTV(data);
          // noop
        })
        .catch(error => {
          console.error(error);
        });
    }
  };

  const flattenSections = sections => {
    return sections.reduce((acc, sectionObj) => {
      if (sectionObj.children) {
        return [
          ...acc,
          sectionObj.section,
          ...flattenSections(sectionObj.children),
        ];
      }
      return [...acc, sectionObj.section];
    }, []);
  };

  const onFilterSectionClick = sec => {
    const pushOrPop = () => {
      if (activeTV.filteredOutSections.includes(sec.name)) {
        return activeTV.filteredOutSections.filter(el => el !== sec.name);
      }
      return [...activeTV.filteredOutSections, sec.name];
    };

    axios
      .put(
        `/api/proxy/v2/businesses/${id}/gntv/${activeTV.id}`,
        {
          ...activeTV,
          filteredOutSections: pushOrPop(),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(({ data }) => {
        if (activeTV.filteredOutSections.includes(sec.name)) {
          setActiveTV({
            ...activeTV,
            filteredOutSections: activeTV.filteredOutSections.filter(
              el => el !== sec.name
            ),
          });
        } else {
          setActiveTV({
            ...activeTV,
            filteredOutSections: [...activeTV.filteredOutSections, sec.name],
          });
        }
        setActiveTV(data);
      })
      .catch(error => {
        console.error(error);
      });
  };

  const determineIfOn = (name, type) => {
    // * Determines wether album/section checkboxes should be toggled ON or OFF
    if (type === 'section') {
      if (activeTV.filteredOutSections.includes(name)) {
        return false;
      }
      return true;
    }
    if (type === 'album') {
      if (activeTV.albumNames.includes(name)) {
        return false;
      }
      return true;
    }
  };

  const onAlbumClick = album => {
    // add or remvove an album when a user clicks on one
    const pushOrPop = () => {
      if (activeTV.albumNames.includes(album.name)) {
        setActiveTV({
          ...activeTV,
          albumNames: activeTV.albumNames.filter(el => el !== album.name),
        });
        return activeTV.albumNames.filter(el => el !== album.name);
      }
      setActiveTV({
        ...activeTV,
        albumNames: [...activeTV.albumNames, album.name],
      });
      return [...activeTV.albumNames, album.name];
    };

    axios
      .put(
        `/api/proxy/v2/businesses/${id}/gntv/${activeTV.id}`,
        {
          ...activeTV,
          albumNames: pushOrPop(),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(({ data }) => {
        setActiveTV(data);
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleUpdate = e => {
    e.preventDefault();

    if (e.target.name === 'slideDuration') {
      axios
        .put(
          `/api/proxy/v2/businesses/${id}/gntv/${activeTV.id}`,
          {
            ...activeTV,
            [e.target.name]: parseInt(tvDurationInput),
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then(({ data }) => {
          setActiveTV(data);
        })
        .catch(error => {
          console.error(error);
        });
    } else {
      axios
        .put(
          `/api/proxy/v2/businesses/${id}/gntv/${activeTV.id}`,
          {
            ...activeTV,
            otherOptions: {
              ...activeTV.otherOptions,
              [e.target.name]: tvNameInput,
            },
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then(({ data }) => {
          setActiveTV(data);
        })
        .catch(error => {
          console.error(error);
        });
    }
  };

  const handleCheckChange = name => {
    setActiveTypes([...activeTypes]);
    const addOrRemove = () => {
      if (activeTypes.includes(name)) {
        setActiveTypes(activeTypes.filter(el => el !== name));
        return activeTypes.filter(el => el !== name);
      }
      setActiveTypes([...activeTypes, name]);
      return [...activeTypes, name];
    };
    axios
      .put(
        `/api/proxy/v2/businesses/${id}/gntv/${activeTV.id}`,
        {
          ...activeTV,
          activeTypes: {
            list1: addOrRemove(),
          },
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(({ data }) => {
        setActiveTV(data);
      })
      .catch(error => {
        console.error(error);
      });
  };

  const secToMS = num => 1000 * num;

  const handleDurationComplete = time => {
    axios
      .put(
        `/api/proxy/v2/businesses/${id}/gntv/${activeTV.id}`,
        {
          ...activeTV,
          slideDuration: secToMS(time),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(({ data }) => {
        setActiveTV(data);
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleListViewComplete = () => {
    axios
      .put(
        `/api/proxy/v2/businesses/${id}/gntv/${activeTV.id}`,
        {
          ...activeTV,
          otherOptions: {
            ...activeTV.otherOptions,
            listViewDuration: listViewDurationInput,
          },
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(({ data }) => {
        setActiveTV(data);
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handlePageDataChange = e => {
    const pageViewData = activeTV.otherOptions.pageViewData;

    Object.keys(pageViewData).forEach(v => (pageViewData[v] = false));

    pageViewData[e.value] = true;

    axios
      .put(
        `/api/proxy/v2/businesses/${id}/gntv/${activeTV.id}`,
        {
          ...activeTV,
          otherOptions: {
            ...activeTV.otherOptions,
            pageViewData: {
              ...pageViewData,
            },
          },
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(({ data }) => {
        setActiveTV(data);
      })
      .catch(error => {
        console.error(error);
      });
  };

  return (
    <React.Fragment>
      {controlOpen ? (
        <TVForm
          controlOpen={controlOpen}
          setControlOpen={setControlOpen}
          tvNameInput={tvNameInput}
          activeTV={activeTV}
          setTvNameInput={setTvNameInput}
          handleUpdate={handleUpdate}
          durationRef={durationRef}
          toolTipContent={toolTipContent}
          tvDurationInput={tvDurationInput}
          setTvDurationInput={setTvDurationInput}
          handleDurationComplete={handleDurationComplete}
          tickerRef={tickerRef}
          shoutTickerInput={shoutTickerInput}
          handleSwitch={handleSwitch}
          pricesRef={pricesRef}
          showPricesInput={showPricesInput}
          activeTypesRef={activeTypesRef}
          activeTypes={activeTypes}
          handleCheckChange={handleCheckChange}
          listViewRef={listViewRef}
          listViewInput={listViewInput}
          listSpeedRef={listSpeedRef}
          listViewDurationInput={listViewDurationInput}
          setListViewDurationInput={setListViewDurationInput}
          handleListViewComplete={handleListViewComplete}
          setShowSectionToggle={setShowSectionToggle}
          showSectionToggle={showSectionToggle}
          allSections={allSections}
          determineIfOn={determineIfOn}
          onFilterSectionClick={onFilterSectionClick}
          setShowGalleryToggle={setShowGalleryToggle}
          showGalleryToggle={showGalleryToggle}
          onAlbumClick={onAlbumClick}
          albums={albums}
          handleViewType={handleViewType}
          handlePageDataChange={handlePageDataChange}
        />
      ) : (
        ''
      )}
    </React.Fragment>
  );
};

export default ActiveTVController;



// WEBPACK FOOTER //
// ./src/views/Components/Modals/ActiveTVController.js